import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const MaintenanceParty = () => {
  return <ObsIframe path="/maintenanceParty" />;
};

export default React.memo(MaintenanceParty);
